import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { signUp } from '../actions/signUpActions';
import { getCycles } from '../actions/cycleActions';
import AdministratorForm from '../components/user/AdministratorForm';
import DirectorForm from '../components/user/DirectorForm';
import TeacherForm from '../components/user/TeacherForm';
import UserTypeForm from '../components/user/UserTypeForm';
import '../styles/sign-up.scss';
import cbcvLogo from '../assets/logo2016cuadrado_sinfondo.png';
import { userTypeOptions } from '../constants/constants';
import { toSelect } from '../utils/helpers';

class SignUpPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      type: ''
    };

    this.setUserType = this.setUserType.bind(this);
  }

  setUserType(option) {
    const type = option.get('type');
    this.setState({ type });
    if (type === 'Director') {
      const { cycles, getCycles } = this.props;
      _.isEmpty(cycles) && getCycles();
    }
  }

  render() {
    const { type } = this.state;
    const { graduatedTeacher, specialTeacher, cycles, signUp } = this.props;
    const onSubmit = user => signUp(user.toJS());

    const userForm = () => {
      switch (type) {
        case 'Administrator':
          return <AdministratorForm onSubmit={onSubmit} />;
        case 'Director':
          return <DirectorForm onSubmit={onSubmit} cycles={cycles} />;
        default: {
          const initialValues = {
            type,
            graduated: false,
            specialTeacher: false
          };
          return (
            <TeacherForm
              onSubmit={onSubmit}
              initialValues={initialValues}
              graduatedTeacher={graduatedTeacher}
              specialTeacher={specialTeacher}
            />
          );
        }
      }
    };
    const userTypeLabel = () => {
      const option = _.find(userTypeOptions, item =>
        item.value === type
      );
      return option.label;
    };

    return (
      <div id="sign-up">
        <img alt="logo" src={cbcvLogo} />
        <div className="login-wrapper">
          <h4>
            {`CREAR CUENTA ${type && userTypeLabel().toUpperCase()}`}
          </h4>
          { type ? userForm() : <UserTypeForm onSubmit={this.setUserType} /> }
        </div>
      </div>
    );
  }
}

const { func, bool, array } = PropTypes;

SignUpPage.propTypes = {
  signUp: func.isRequired,
  getCycles: func.isRequired,
  graduatedTeacher: bool,
  specialTeacher: bool,
  cycles: array
};

const mapState = (state) => {
  const signUpForm = state.getIn(['form', 'signUp']);
  const validForm = signUpForm && signUpForm.get('values');
  return {
    graduatedTeacher: validForm && signUpForm.getIn(['values', 'graduated']),
    specialTeacher: validForm && signUpForm.getIn(['values', 'specialTeacher']),
    cycles: toSelect(state.get('cycle').toJS())
  };
};

const mapDispatch = dispatch => ({
  signUp: user => dispatch(signUp(user)),
  getCycles: () => dispatch(getCycles())
});

export default connect(mapState, mapDispatch)(SignUpPage);



// WEBPACK FOOTER //
// ./src/containers/SignUpPage.js